import Rest from './base/Rest';

export default class ArtificialInvoices extends Rest {
    static resource = 'artificial-invoices';
}
